import React from "react";

const ReviewListItem = ({name, review}) => {
  const initialName = name.split(" ").slice(0,2).map((str) => str[0]).join("");
  return (
    <div className='flex border border-gray-200 rounded-lg p-4'>
      <div className='flex flex-col items-center w-1/5 md:w-36'>
        <div className="w-10 aspect-square rounded-lg bg-slate-300 flex justify-center items-center">
          <span className="text-white font-semibold">{initialName}</span>
        </div>
        <p className='w-full mx-2 text-xs text-center text-gray-800 font-semibold mt-2 truncate'>
          {name}
        </p>
      </div>
      <p className='flex-grow text-gray-600 text-xs font-italic px-6 tracking-wide leading-loose'>
        {review}
      </p>
    </div>
  );
}

export default ReviewListItem;